import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import LineupsSnippetNotFoundError from './lineups-snippet-not-found-error';
import {lineupsSnippetMap} from 'components/organisms/late-swap/services/maps';

const LineupPlayersSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        try {
            return lineupsSnippetMap[site][sport][gameType]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new LineupsSnippetNotFoundError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default LineupPlayersSnippetFactory;
